import { ValidationErrors } from '@angular/forms';
import { ReplaceParam, ValidateLengthOptions } from '@lib/interfaces';
import {
  VALIDATE_CHINA_NUMBER,
  VALIDATE_FULL_NAME,
  VALIDATE_IMMIGRATION_DATE_REQUIRED,
  VALIDATE_ISSUING_COUNTRY_REQUIRED,
  VALIDATE_PASSPORT_NUMBER_REQUIRED,
  VALIDATE_US_VISA_NUMBER_LENGTH,
  VALIDATE_VISA_NUMBER,
  VALIDATE_VISA_NUMBER_ALPHA_NUMBER,
  VALIDATE_VISA_NUMBER_LENGTH,
} from '@common/helpers/constants/my-booking/passenger-information-input-modal.constant';
import { ValidatorMaxLengthOptions } from '@common/helpers/validations/max-length.validator';

export const RepresentativeInformationState = {
  Params: {
    Email: {
      key: 0,
      value: 'label.eMailAddress.passengerInput',
    } as ReplaceParam,
    ConfirmEmail: {
      key: 0,
      value: 'label.confirmMailAddress',
    } as ReplaceParam,
    PhoneNumberType: {
      key: 0,
      value: 'label.telNumber.passengerInput',
    },
    CountryCode: {
      key: 0,
      value: 'label.countryCode',
    } as ReplaceParam,
    PhoneNumber: {
      key: 0,
      value: 'label.telephoneNumber.passengerInput',
    } as ReplaceParam,
  },
  Errors: {
    ConfirmEmail: {
      'validate-email': {
        errorMsgId: 'E0461',
        params: {
          key: 0,
          value: 'label.confirmMailAddress',
        },
      },
    } as ValidationErrors,
  },
};

export const UpgradeNotificationEmailState = {
  Params: {
    Email: {
      key: 0,
      value: 'label.eMailAddress',
    } as ReplaceParam,
    ConfirmEmail: {
      key: 0,
      value: 'label.confirmMailAddress',
    } as ReplaceParam,
  },
  Errors: {
    ConfirmEmail: {
      'validate-email': {
        errorMsgId: 'E0461',
        params: {
          key: 0,
          value: 'label.confirmMailAddress',
        },
      },
    } as ValidationErrors,
  },
};

export const PassengerInformationState = {
  Params: {
    ContactNumber: {
      key: 0,
      value: 'label.telephoneNumber.passengerInput',
    } as ReplaceParam,
    Email: {
      key: 0,
      value: 'label.eMailAddress',
    } as ReplaceParam,
    ConfirmEmail: {
      key: 0,
      value: 'label.confirmMailAddress',
    } as ReplaceParam,
    FirstName: {
      key: 0,
      value: 'label.firstName',
    } as ReplaceParam,
    MiddleName: {
      key: 0,
      value: 'label.middleName',
    } as ReplaceParam,
    LastName: {
      key: 0,
      value: 'label.lastName',
    } as ReplaceParam,
    Gender: {
      key: 0,
      value: 'label.gender',
    } as ReplaceParam,
    FFP: {
      key: 0,
      value: 'label.ffp',
    } as ReplaceParam,
    Title: {
      key: 0,
      value: 'label.title',
    } as ReplaceParam,
    SecondContactPhoneOwner: {
      key: 0,
      value: 'label.phoneNumberOwner',
    } as ReplaceParam,
    CountryCode: {
      key: 0,
      value: 'label.countryCode',
    } as ReplaceParam,
  },
  ValidateOptions: {
    LastNameMinLength: {
      min: 2,
      params: [
        {
          key: 0,
          value: 'label.lastName',
        },
        {
          key: 1,
          value: 2,
        },
      ],
    } as ValidateLengthOptions,
    SecondContactPhoneOwnerMinLenth: {
      min: 2,
      params: [
        {
          key: 0,
          value: 'label.phoneNumberOwner',
        },
        {
          key: 1,
          value: 2,
        },
      ],
    } as ValidateLengthOptions,
  },
  Errors: {
    ConfirmEmail: {
      'validate-email': {
        errorMsgId: 'E0461',
        params: {
          key: 0,
          value: 'label.confirmMailAddress',
        },
      },
    } as ValidationErrors,
    FFP: {
      [VALIDATE_FULL_NAME]: {
        errorMsgId: 'E1817', // 文言調整中 - https://asy-pd.backlog.com/view/ANAUIUXS2_DEV-18032
        params: [],
      },
    } as ValidationErrors,
    SecondContactPhoneNumber: {
      'validate-duplicate-phone-number': {
        errorMsgId: 'E0874',
        params: {
          key: 0,
          value: 'label.telephoneNumber.passengerInput',
        },
      },
    } as ValidationErrors,
  },
};

export const PassportInformationState = {
  Params: {
    PassportNumber: {
      key: 0,
      value: 'label.passportNumber',
    } as ReplaceParam,
    NationalityCountry: {
      key: 0,
      value: 'label.nationality',
    } as ReplaceParam,
    IssuingCountry: {
      key: 0,
      value: 'label.issuingCountry',
    } as ReplaceParam,
  },
  ValidateOptions: {
    PassportNumberMinLength: {
      min: 5,
      params: [
        {
          key: 0,
          value: 'label.passportNumber',
        },
        {
          key: 1,
          value: 5,
        },
      ],
    } as ValidateLengthOptions,
  },
  Errors: {
    FullName: {
      [VALIDATE_FULL_NAME]: {
        errorMsgId: 'E0483',
        params: [],
      },
    } as ValidationErrors,
    PassportNumberRequired: {
      [VALIDATE_PASSPORT_NUMBER_REQUIRED]: {
        errorMsgId: 'E0001',
        params: [
          {
            key: 0,
            value: 'label.passportNumber',
          },
        ],
      },
    } as ValidationErrors,
    IssuingCountryRequired: {
      [VALIDATE_ISSUING_COUNTRY_REQUIRED]: {
        errorMsgId: 'E0001',
        params: [
          {
            key: 0,
            value: 'label.issuingCountry',
          },
        ],
      },
    } as ValidationErrors,
  },
};

export const ImmigrationInformationState = {
  Params: {
    ChineseCitizenIdentificationNumber: {
      key: 0,
      value: 'label.citizenIdentificationNumber',
    } as ReplaceParam,
    VisaNumber: {
      key: 0,
      value: 'label.visaNumber',
    } as ReplaceParam,
    Country: {
      key: 0,
      value: 'label.countryOfResidence',
    } as ReplaceParam,
    KnownTravelerNumber: {
      key: 0,
      value: 'label.knownTravelerNumber',
    } as ReplaceParam,
    GreenCardNumber: {
      key: 0,
      value: 'label.GreenCardNumber',
    } as ReplaceParam,
    RedressNumber: {
      key: 0,
      value: 'label.redressNumber',
    } as ReplaceParam,
    ZipCode: {
      key: 0,
      value: 'label.zipCode',
    } as ReplaceParam,
    CityName: {
      key: 0,
      value: 'label.city',
    } as ReplaceParam,
    StateName: {
      key: 0,
      value: 'reader.state',
    } as ReplaceParam,
    Hotel: {
      key: 0,
      value: 'label.addressInTheUS',
    } as ReplaceParam,
  },
  ValidateOptions: {
    GreenCardNumberMinLength: {
      min: 5,
      params: [
        {
          key: 0,
          value: 'label.GreenCardNumber',
        },
        {
          key: 1,
          value: 5,
        },
      ],
    } as ValidateLengthOptions,
    VisaNumberMaxLength: {
      max: 20,
      errorMsgId: 'E1246',
      params: [
        {
          key: 0,
          value: 'label.visaNumber',
        },
        {
          key: 1,
          value: 20,
        },
      ],
    } as ValidatorMaxLengthOptions,
    VisaNumberFixedLength: {
      fixed: 8,
      errorMsgId: 'E1247',
      params: [
        {
          key: 0,
          value: 'label.visaNumber',
        },
        {
          key: 1,
          value: 8,
        },
      ],
    } as ValidateLengthOptions,
  },
  Errors: {
    ConfirmEmail: {
      'validate-email': {
        errorMsgId: 'E0461',
        params: {
          key: 0,
          value: 'label.confirmMailAddress',
        },
      },
    } as ValidationErrors,
    ChineseCitizenIdentificationNumber: {
      [VALIDATE_CHINA_NUMBER]: {
        errorMsgId: 'E0491',
        params: [
          {
            key: 0,
            value: 'label.citizenIdentificationNumber',
          },
        ],
      },
    } as ValidationErrors,
    VisaNumber: {
      [VALIDATE_VISA_NUMBER]: {
        errorMsgId: 'E0001',
        params: [
          {
            key: 0,
            value: 'label.visaNumber',
          },
        ],
      },
    } as ValidationErrors,
    VisaNumberAlphaNumber: {
      [VALIDATE_VISA_NUMBER_ALPHA_NUMBER]: {
        errorMsgId: 'E0005',
        params: [
          {
            key: 0,
            value: 'label.visaNumber',
          },
        ],
      },
    } as ValidationErrors,
    USVisaNumberLength: {
      [VALIDATE_VISA_NUMBER_LENGTH]: {
        errorMsgId: 'E0674',
        params: [
          {
            key: 0,
            value: 'label.visaNumber',
          },
          {
            key: 1,
            value: 8,
          },
        ],
      },
    } as ValidationErrors,
    VisaNumberLength: {
      [VALIDATE_US_VISA_NUMBER_LENGTH]: {
        errorMsgId: 'E0673',
        params: [
          {
            key: 0,
            value: 'label.visaNumber',
          },
          {
            key: 1,
            value: '20',
          },
        ],
      },
    } as ValidationErrors,
    VisaDateRequired: {
      [VALIDATE_IMMIGRATION_DATE_REQUIRED]: {
        errorMsgId: '',
        params: [
          {
            key: 0,
            value: 'label.passportNumber',
          },
        ],
      },
    } as ValidationErrors,
  },
};

export const NotificationInformationState = {
  ContactEmail: {
    key: 0,
    value: 'label.passengerContactInformation',
  } as ReplaceParam,
};

export const ArrivalDepartureNoticeInformationState = {
  Params: {
    Recipient: {
      key: 0,
      value: 'label.eMailRecipient',
    } as ReplaceParam,
    Email: {
      key: 0,
      value: 'label.eMailAddress',
    } as ReplaceParam,
    ConfirmEmail: {
      key: 0,
      value: 'label.confirmMailAddress',
    } as ReplaceParam,
    Lang: {
      key: 0,
      value: 'label.language',
    } as ReplaceParam,
  },
  Errors: {
    ConfirmEmail: {
      'validate-email': {
        errorMsgId: 'E0461',
        params: {
          key: 0,
          value: 'label.confirmMailAddress',
        },
      } as ValidationErrors,
    } as ValidationErrors,
  },
};

export const SpecialAssistanceRequestState = {
  WalkingAbility: {
    errorMsgId: 'E0001',
    params: {
      key: 0,
      value: 'label.walking.ability',
    },
  },
  FoldingType: {
    errorMsgId: 'E0001',
    params: {
      key: 0,
      value: 'label.foldingWheelchair',
    },
  },
  WheelchairType: {
    errorMsgId: 'E0001',
    params: {
      key: 0,
      value: 'label.wheelchairType',
    },
  },
  BatteryType: {
    errorMsgId: 'E0001',
    params: {
      key: 0,
      value: 'label.batteryType',
    },
  },
  Wheelchairs: {
    errorMsgId: 'E0002',
    params: {
      key: 0,
      value: 'label.useWheelchair',
    },
  },
  DoctorName: {
    params: {
      key: 0,
      value: 'label.doctorName',
    },
  },
  DoctorNameMaxLength: {
    max: 40,
    errorMsgId: 'E0674',
    params: [
      {
        key: 0,
        value: 'label.doctorName',
      },
      {
        key: 1,
        value: 40,
      },
    ],
  } as ValidatorMaxLengthOptions,
  PhoneNumber: {
    errorMsgId: 'E0001',
    params: {
      key: 0,
      value: 'label.doctorsContact',
    },
  },
  dueDate: {
    errorMsgId: 'E0001',
    params: {
      key: 0,
      value: 'label.expectedDate',
    },
  },
  PhoneCountry: {
    errorMsgId: 'E0001',
    params: {
      key: 0,
      value: 'label.countryCode',
    },
  },
  Condition: {
    errorMsgId: 'E0001',
    params: {
      key: 0,
      value: 'label.currentStatus',
    },
  },
  Depth: {
    params: {
      key: 0,
      value: 'label.depth',
    },
  },
  Width: {
    params: {
      key: 0,
      value: 'label.width',
    },
  },
  Height: {
    params: {
      key: 0,
      value: 'label.height',
    },
  },
  Weight: {
    params: {
      key: 0,
      value: 'label.weight',
    },
  },
};
